<div class="esf-notifications">
  <div
    class="esf-notification esf-notification--multiple"
    [ngClass]="getNotificationStyles(notification.type)"
    *ngFor="let notification of notifications"
  >
    <div class="esf-container" [innerHTML]="notification.message"></div>
    <div class="esf-notification__close" (click)="closeNotification(notification)">
      <svg class="esf-icon esf-icon--white" width="16" height="16">
        <use xlink:href="#esf-icon-close-16"></use>
      </svg>
    </div>
  </div>
</div>
